module.exports = __webpack_public_path__ + "media/startSound.ca36aff4.wav";